import * as React from "react";
import { css } from "@emotion/core";
import { Button, ButtonGroup, Popover } from "@blueprintjs/core";

import { withStopPropagation } from "utils/";

const colors = [
  "#448AFF",
  "#FA5252",
  "#7C4DFF",
  "#0bff07",
  "#FBE602",
  "#FAAB3F",
  "#3DFDFF",
  "#E040FB",
  "#B6F10F",
  "#F9F9F9",
];

export const markerStyle = (color = null) =>
  css`
    & path {
      fill: ${color || "currentColor"};
    }
  `;

const useColorPicker = () => {
  const [open, setOpen] = React.useState(false);

  return {
    open,
    toggle: (event) => {
      setOpen((p) => !p);
    },
    close: () => setOpen(false),
    onInteraction: setOpen,
  };
};

const ColorPicker = ({ color, onSelectColor }) => {
  const { open, toggle, close, onInteraction } = useColorPicker();

  return (
    <Popover
      onInteraction={onInteraction}
      isOpen={open}
      usePortal={true}
      position="top"
      content={
        <ButtonGroup>
          {colors.map((color) => (
            <Button
              key={color}
              icon="tint"
              css={markerStyle(color)}
              onClick={withStopPropagation(() => {
                onSelectColor(color);
                close();
              })}
            />
          ))}
        </ButtonGroup>
      }
    >
      <Button
        icon="tint"
        css={markerStyle(color)}
        small
        onClick={withStopPropagation(toggle)}
      />
    </Popover>
  );
};

export default ColorPicker;
